import { WorldObjectType } from "../../api";
import { PrimitiveObject } from "./PrimitiveObject";
export class SpriteObject extends PrimitiveObject {
    constructor(sprite, objectId, pickingUserId) {
        super(sprite);
        this.object = sprite;
        this.id = objectId;
        this.pickingUserId = pickingUserId;
    }
    getBoundingVolume() {
        this.object.updateMatrix();
        if (this.object.geometry.boundingSphere === null) {
            throw new Error("Mesh bounding sphere not generated. This is an internal bug.");
        }
        const sphere = this.object.geometry.boundingSphere.clone().applyMatrix4(this.object.matrix);
        return [sphere.center.x, sphere.center.y, sphere.center.z, sphere.radius];
    }
    getObjectType() {
        return WorldObjectType.SpriteObject;
    }
    constructMaterial(material) {
        switch (material.type) {
            case "basicOpaque":
            case "basicAlpha":
                this.object.material.color.r = material.color.r;
                this.object.material.color.g = material.color.g;
                this.object.material.color.b = material.color.b;
                this.object.material.needsUpdate = true;
                break;
            case "physicalOpaque":
            case "physicalAlpha":
                this.object.material.color.r = material.baseColor.r;
                this.object.material.color.g = material.baseColor.g;
                this.object.material.color.b = material.baseColor.b;
                this.object.material.needsUpdate = true;
                break;
        }
    }
}
